import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TourMatMenu, TourService } from 'ngx-ui-tour-md-menu';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { GtmService } from './shared/services/gtm.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    TranslateModule,
    TourMatMenu,
    RouterModule,
    MatMenuModule,
    MatIcon,
    MatCardModule,
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  private readonly ENV_FLAG = '__env_context_pushed__';

  constructor(
    public readonly tourService: TourService,
    private readonly router: Router,
    private readonly gtmService: GtmService,
  ) {}

  ngAfterViewInit(): void {
    this.gtmService.pushEventAfterGtmStart(
      {
        event: 'environment_context',
        environment: environment.environment,
      },
      this.ENV_FLAG,
    );
  }

  redirectRouter() {
    this.tourService.end();
    this.goFullscreen();
    this.router.navigate(['/cdm-metrics/my-dashboard']);
  }

  goFullscreen() {
    const docElement: HTMLElement = document?.documentElement;

    if (document?.exitFullscreen) {
      document?.exitFullscreen();
    } else if ((docElement as any)?.mozCancelFullScreen) {
      (docElement as any)?.mozCancelFullScreen();
    } else if ((docElement as any)?.webkitExitFullscreen) {
      (docElement as any)?.webkitExitFullscreen();
    } else if ((docElement as any)?.msExitFullscreen) {
      (docElement as any)?.msExitFullscreen();
    }
  }
}

